'use client';

export const IS_GTM_ENABLED =
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS !== undefined &&
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS !== '';

export const trackingConfig = {
  gtmId: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS || '',
  cookieBannerCookieName: 'cookieConsent',
};
